export const uploadInputId = 'user-avatar';
export const storageUserPhotoKey = 'userPhoto';
